import React from 'react';
import Link from 'next/link';
import { LogOut, Activity, AlertTriangle, LucideLayoutDashboard, Plus } from 'lucide-react';
import Avatar from "../../common/Avatar";

export default function MobileMenu({
    showMobileMenu,
    userProfile,
    userDataFromLocal,
    getInitials,
    isWalletConnected,
    walletAddress,
    formatAddress,
    connectedWallet,
    solBalance,
    isLoadingSolBalance,
    solBalanceError,
    selectedNetworkData,
    refreshSolBalance,
    selectedNetwork,
    networks,
    // notifications,
    // autobotStatus,
    // getAutobotStatusColor,
    setShowLogoutModal
}) {
    // console.log(userDataFromLocal, "userDataFromLocal")
    return (
        showMobileMenu && (
            <div className="lg:hidden border-t border-gray-700/50 bg-gray-900/50 backdrop-blur-sm pb-4">
                <div className="p-4 space-y-3">
                    {/* Mobile User Profile */}
                    <div className="flex items-center space-x-3 p-3 bg-gray-800/60 rounded-lg">
                        <Avatar
                            src={userDataFromLocal?.user?.avatar || userProfile.avatar}
                            name={userDataFromLocal?.user?.username || userProfile.name}
                            getInitials={getInitials}
                        />
                        <div className="flex-1">
                            <div className="text-white font-medium">{userDataFromLocal?.user?.username || userProfile.name}</div>
                            {(userDataFromLocal?.user?.email || userDataFromLocal?.email || userProfile?.email) && (
                                <div className="text-gray-400 text-sm">
                                    {userDataFromLocal?.user?.email || userDataFromLocal?.email || userProfile?.email}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Mobile Wallet Info (if connected) */}
                    {isWalletConnected && (
                        <div className="p-3 bg-gray-800/60 rounded-lg">
                            <div className="flex items-center justify-between mb-2">
                                <span className="text-gray-400 text-sm">Wallet</span>
                                <div className="flex items-center space-x-2">
                                    <button
                                        onClick={refreshSolBalance}
                                        disabled={isLoadingSolBalance}
                                        className="p-1 text-gray-400 hover:text-gray-300 transition-colors disabled:opacity-50"
                                        title="Refresh balance"
                                    >
                                        <Activity className="w-3 h-3" />
                                    </button>
                                    <span className="text-xs text-gray-400">{connectedWallet}</span>
                                </div>
                            </div>
                            <div className="text-white font-mono text-sm mb-1">{formatAddress(walletAddress)}</div>
                            <div className="text-gray-300 font-semibold">
                                {solBalanceError ? (
                                    <div className="flex items-center space-x-1 text-red-400">
                                        <AlertTriangle className="w-3 h-3" />
                                        <span className="text-sm">Error</span>
                                    </div>
                                ) : (
                                    `${solBalance.toFixed(6)} ${selectedNetworkData?.symbol || 'SOL'}`
                                )}
                            </div>
                        </div>
                    )}

                    {/* Mobile Network Selector */}
                    <div>
                        <label className="text-gray-400 text-xs font-medium block mb-1">Network</label>
                        <select
                            value={selectedNetwork || 'solana'}
                            // onChange={(e) => console.log('Network changed:', e.target.value)}
                            className="w-full px-3 py-2 bg-gray-800/60 border border-gray-600/50 rounded-lg text-white text-sm focus:border-gray-500/40 focus:outline-none"
                        >
                            {networks.map((network) => (
                                <option key={network.id} value={network.id}>
                                    {network.name} ({network.symbol})
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Mobile Actions Grid */}
                    <div className="grid grid-cols-3 gap-2 mb-2">
                  
                        <Link href="/" className="flex flex-col items-center justify-center p-3 bg-gray-800/60 rounded-lg text-gray-400 hover:text-gray-300 transition-colors" rel="noopener noreferrer">
                            <Plus className="w-4 h-4 mb-1" />
                            <span className="text-xs">Create Bot</span>
                            
                        </Link>
                        <Link href="/dashboard" className="flex flex-col items-center justify-center p-3 bg-gray-800/60 rounded-lg text-gray-400 hover:text-gray-300 transition-colors" rel="noopener noreferrer">
                            <LucideLayoutDashboard className="w-4 h-4 mb-1" />
                            <span className="text-xs">Dashboard</span>
                        </Link>
                        <button
                            onClick={() => setShowLogoutModal(true)}
                            className="flex flex-col items-center justify-center p-3 bg-gray-800/60 rounded-lg text-red-400 hover:text-red-300 transition-colors"
                        >
                            <LogOut className="w-4 h-4 mb-1" />
                            <span className="text-xs">Logout</span>
                        </button>
                    </div>

                    {/* Mobile AI Status */}
                    {/* <div className="flex items-center justify-between p-3 bg-emerald-500/10 border border-gray-500/20 rounded-lg">
                        <div className="flex items-center space-x-2">
                            <Cpu className="w-4 h-4 text-gray-300" />
                            <span className="text-sm text-gray-300 font-medium">AI Trading</span>
                        </div>
                        <div className="flex items-center space-x-1">
                            <span className="text-xs text-gray-300 capitalize">{autobotStatus}</span>
                            <div className={`w-2 h-2 rounded-full animate-pulse ${getAutobotStatusColor()}`} />
                        </div>
                    </div> */}
                </div>
            </div>
        )
    );
} 